import { IconButton } from "@mui/material";
import { useStyles } from "./TablePaginator.styles";
import { ITablePaginator } from "./TablePaginatorInterfaces";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useTranslation } from "react-i18next";

const TablePaginator = ({
    isFirstPage,
    onClickNextPage,
    onClickPreviousPage,
    currentPage,
    totalPages,
    isLastPage,
}: ITablePaginator) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <div className={classes.paginationWrapper}>
            <IconButton disabled={isFirstPage} className={classes.paginationButton} onClick={onClickPreviousPage}>
                <ChevronLeftIcon />
            </IconButton>
            <span className={classes.paginationText}>
                {t("table_paginator.page")} {currentPage} {t("table_paginator.of")} {totalPages}
            </span>
            <IconButton disabled={isLastPage} className={classes.paginationButton} onClick={onClickNextPage}>
                <ChevronRightIcon />
            </IconButton>
        </div>
    );
};

export default TablePaginator;
